// src/data/newsData.js

import newsFeatured01 from "../assets/images/news/lanuch-post-news-01/news01-featured-image.jpg";
import newsBody01A from "../assets/images/news/lanuch-post-news-01/news01-image-01.jpg";
import newsBody01B from "../assets/images/news/lanuch-post-news-01/news01-image-03.jpg";
import newsBody01C from "../assets/images/news/lanuch-post-news-01/news01-image-04.jpg";
import newsBody01D from "../assets/images/news/lanuch-post-news-01/news01-image-05.jpg";
import newsBody01E from "../assets/images/news/lanuch-post-news-01/news01-image-06.jpg";

// import newsFeatured02 from "../assets/news/news-featured-02.jpg";
// import newsBody02A from "../assets/news/news-body-02-a.jpg";

// import newsFeatured03 from "../assets/news/news-featured-03.jpg";
// import newsFeatured04 from "../assets/news/news-featured-04.jpg";
// import newsFeatured05 from "../assets/news/news-featured-05.jpg";

/*
  contentBlocks supports:
  - paragraph
  - image

  paragraph block:
  {
    type: "paragraph",
    content: {
      en: [
        { type: "text", value: "Some text " },
        { type: "link", value: "click here", href: "/contact-us", target: "_self" },
        { type: "text", value: " more text." }
      ],
      ar: [
        { type: "text", value: "..." },
        { type: "link", value: "اضغط هنا", href: "/contact-us", target: "_self" },
        { type: "text", value: "..." }
      ]
    }
  }

  image block:
  {
    type: "image",
    src: imagePath,
    alt: {
      en: "English alt",
      ar: "Arabic alt"
    }
  }
*/

export const newsData = [
    {
        id: 1,
        slug: "landking-showroom-riyadh-opening-btatc",
        date: "2025-12-10",
        featuredImage: newsFeatured01,
        featuredAlt: {
            en: "LANDKING Riyadh showroom opening ceremony with commercial trucks on display",
            ar: "حفل افتتاح معرض لاندكنج في الرياض مع عرض الشاحنات التجارية",
        },
        title: {
            en: "LANDKING Showroom Opens in Riyadh: BTATC Launches H-Series and EH Electric Trucks in Saudi Arabia",
            ar: "افتتاح صالة عرض لاندكينج في الرياض: BTATC تطلق شاحنات H-Series وشاحنات EH الكهربائية في المملكة العربية السعودية",
        },
        excerpt: {
            en: "BTATC officially introduced the LANDKING brand in Riyadh with a showroom opening that highlighted the H-Series and EH Series for the Saudi market.",
            ar: "أطلقت BTATC رسميًا علامة لاندكنج في الرياض من خلال افتتاح المعرض، مع إبراز سلسلة H وسلسلة EH للسوق السعودي.",
        },
        contentBlocks: [
            {
                type: "image",
                src: newsBody01A,
                alt: {
                    en: "LANDKING trucks displayed inside the Riyadh showroom during the opening event",
                    ar: "شاحنات لاندكنج معروضة داخل معرض الرياض خلال فعالية الافتتاح",
                },
            },

            {
                type: "paragraph",
                content: {
                    en: [
                        {
                            type: "text",
                            value:
                                "BTATC (Bawabat Altawrid Alalamiya for Trading Company) officially opened the LANDKING showroom in Riyadh, giving Saudi businesses a new destination to explore modern commercial truck solutions. Located in the capital, the showroom strengthens LANDKING’s visibility in Saudi Arabia and gives fleet buyers, logistics operators, and business owners a direct place to experience the brand.",
                        },
                    ],
                    ar: [
                        {
                            type: "text",
                            value: "افتتحت شركة BTATC (بوابة التوريد العالمية للتجارة) رسميًا صالة عرض LANDKING في مدينة الرياض، لتمنح قطاع الأعمال في المملكة وجهة جديدة للتعرّف على أحدث حلول الشاحنات التجارية العصرية. ويأتي افتتاح الصالة في العاصمة ليعزز حضور LANDKING في السوق السعودي، ويوفر لمالكي الأساطيل، ومشغلي الخدمات اللوجستية، وأصحاب الأعمال مكانًا مباشرًا للاطلاع على العلامة التجارية وتجربة ما تقدمه عن قرب.",
                        },
                    ],
                },
            },

            {
                type: "paragraph",
                content: {
                    en: [
                        {
                            type: "text",
                            value:
                                "As LANDKING’s authorized dealer in Saudi Arabia, BTATC is positioning the brand closer to fleet owners, transport companies, delivery operators, and growing businesses across the Kingdom. The Riyadh showroom, located on Eastern Ring Road, Exit 18, creates a direct customer touchpoint for businesses that want to review truck options, discuss requirements, and connect with the local dealer team.",
                        },
                    ],
                    ar: [
                        {
                            type: "text",
                            value:
                                "بصفتها الوكيل المعتمد لعلامة LANDKING في المملكة العربية السعودية، تعمل BTATC على تقريب العلامة من ملاك الأساطيل، وشركات النقل، ومشغلي خدمات التوصيل، والأعمال المتنامية في مختلف أنحاء المملكة. وتقع صالة العرض في الرياض على الطريق الدائري الشرقي، مخرج 18، لتشكّل نقطة تواصل مباشرة مع العملاء من قطاع الأعمال، ممن يرغبون في الاطلاع على خيارات الشاحنات، ومناقشة احتياجاتهم، والتواصل مع فريق الوكيل المحلي.",
                        },
                    ],
                },
            },

            {
                type: "image",
                src: newsBody01B,
                alt: {
                    en: "LANDKING Riyadh Showroom Ceremoney Opening",
                    ar: "حفل افتتاح صالة عرض لاندكنج في الرياض",
                },
            },

            {
                type: "paragraph",
                content: {
                    en: [
                        {
                            type: "text",
                            value:
                                "Held on 10 December 2025, the showroom opening marked an important step in LANDKING’s expansion in Saudi Arabia. The event combined product visibility, local market positioning, and a formal introduction to the H-Series and EH electric truck range for customers in Riyadh.",
                        },
                    ],
                    ar: [
                        {
                            type: "text",
                            value:
                                "أُقيم افتتاح صالة العرض بتاريخ 10 ديسمبر 2025، وشكّل خطوة مهمة في مسيرة توسّع LANDKING داخل المملكة العربية السعودية. وقد جمع الحدث بين إبراز المنتجات، وتعزيز الحضور في السوق المحلي، والتعريف الرسمي بشاحنات H-Series وشاحنات EH الكهربائية للعملاء في مدينة الرياض.",
                        },
                    ],
                },
            },

            {
                type: "image",
                src: newsBody01C,
                alt: {
                    en: "LANDKING H-SERIES AT RIYADH SHOWROOM-BTATC",
                    ar: "لاندكنج H-SERIES في صالة عرض الرياض - BTATC",
                },
            },

            {
                type: "paragraph",
                content: {
                    en: [
                        {
                            type: "text",
                            value:
                                "The opening session welcomed guests to the new LANDKING Riyadh showroom in a setting that combined professionalism with Saudi hospitality. The program included a live cultural performance that gave the launch a local identity and helped create a memorable first impression for attendees.",
                        },
                    ],
                    ar: [
                        {
                            type: "text",
                            value:
                                "استقبلت الجلسة الافتتاحية الضيوف في صالة عرض LANDKING الجديدة بمدينة الرياض، ضمن أجواء جمعت بين الطابع المهني وكرم الضيافة السعودية. كما تضمن البرنامج عرضًا ثقافيًا حيًا منح حفل الافتتاح هوية محلية مميزة، وساهم في تكوين انطباع أول راسخ ولافت لدى الحضور.",
                        },
                    ],
                },
            },

            {
                type: "image",
                src: newsBody01D,
                alt: {
                    en: "Visitors exploring the LANDKING brand experience at the Riyadh showroom",
                    ar: "زوار يطلعون على تجربة علامة لاندكنج في معرض الرياض",
                },
            },


            {
                type: "paragraph",
                content: {
                    en: [
                        {
                            type: "text",
                            value:
                                "The event also opened with Quran recitation and Saudi cultural elements that gave the ceremony a respectful and locally meaningful tone. These moments helped present the showroom launch in a way that connected with the Saudi market while marking LANDKING’s entry into a more visible retail presence in Riyadh.",
                        },
                    ],
                    ar: [
                        {
                            type: "text",
                            value:
                                "كما استُهل الحدث بتلاوة من القرآن الكريم، إلى جانب حضور عناصر من الثقافة السعودية منحت المناسبة طابعًا وقورًا ومعبرًا عن الهوية المحلية. وقد أسهمت هذه اللحظات في تقديم افتتاح صالة العرض بأسلوب ينسجم مع خصوصية السوق السعودي، ويواكب في الوقت ذاته دخول LANDKING إلى حضور أكثر وضوحًا وانتشارًا في قطاع العرض والبيع بمدينة الرياض."
                        },
                    ],
                },
            },

            


            {
                type: "paragraph",
                content: {
                    en: [
                        {
                            type: "text",
                            value:
                                "A major part of the event was the leadership address, where representatives from the international brand side and the local Saudi team shared the business vision behind the showroom opening.",
                        },
                    ],
                    ar: [
                        {
                            type: "text",
                            value:
                                "كان من أبرز محاور الحدث كلمة القيادات، حيث شارك ممثلون من جانب العلامة التجارية على المستوى الدولي، إلى جانب الفريق المحلي في المملكة، رؤيتهم التجارية التي تقف وراء افتتاح صالة العرض.",
                        },
                    ],
                },
            },

            {
                type: "image",
                src: newsBody01E,
                alt: {
                    en: "Finance Director Mr. Khalid Mahmoud recited Quran during LANDKING Riyadh Showroom Opening Ceremoney",
                    ar: "تلا مدير المالية الأستاذ خالد محمود آيات من القرآن الكريم خلال حفل افتتاح صالة عرض لاندكنج في الرياض",
                },
            },

            {
                type: "paragraph",
                content: {
                    en: [
                        {
                            type: "text",
                            value:
                                "Guests also heard from senior leadership representing the international side of the business, highlighting the brand’s broader vision, industrial backing, and commitment to strategic growth. The event then featured remarks from Mr. Amjad Ali, CEO of BTATC, who outlined LANDKING’s ambitions in Saudi Arabia and the value the brand aims to deliver to local customers."
                        },
                    ],
                    ar: [
                        {
                            type: "text",
                            value:
                                "كما استمع الحضور إلى كلمات من قيادات عليا تمثل الجانب الدولي من الأعمال، حيث جرى تسليط الضوء على الرؤية الأوسع للعلامة التجارية، والدعم الصناعي الذي ترتكز عليه، والتزامها بالنمو الاستراتيجي. ثم شهد الحدث كلمة من السيد أمجد علي، الرئيس التنفيذي لشركة BTATC، استعرض فيها طموحات LANDKING في المملكة العربية السعودية، والقيمة التي تسعى العلامة إلى تقديمها للعملاء في السوق المحلي.",
                        },
                    ],
                },
            },


            {
                type: "paragraph",
                content: {
                    en: [
                        {
                            type: "text",
                            value:
                                "One of the most notable highlights of the evening was the warranty-related announcement, which helped reinforce confidence in LANDKING’s product support and ownership proposition. For truck buyers in Saudi Arabia, factors such as durability, uptime, after-sales support, and operating confidence remain central to purchase decisions across transport, cargo, delivery, and fleet applications.",
                        },
                    ],
                    ar: [
                        {
                            type: "text",
                            value:
                                "كان من أبرز محطات الأمسية الإعلان المتعلق بالضمان، والذي أسهم في تعزيز الثقة بمنظومة الدعم التي تقدمها LANDKING وبالقيمة الفعلية لامتلاك شاحناتها. وبالنسبة لعملاء الشاحنات في المملكة العربية السعودية، تظل عوامل مثل الاعتمادية، واستمرارية التشغيل، وخدمات ما بعد البيع، والثقة التشغيلية من أهم الأسس المؤثرة في قرار الشراء، سواء في مجالات النقل، أو الشحن، أو خدمات التوصيل، أو تشغيل الأساطيل.",
                        },
                    ],
                },
            },

            {
                type: "paragraph",
                content: {
                    en: [
                        {
                            type: "text",
                            value:
                                "Among the most anticipated moments of the launch was the official reveal of the LANDKING H-Series and the EH Series, including the electric model introduced during the event. The H-Series is positioned as a light commercial truck range for demanding business use, while the EH Series highlights LANDKING’s move toward electric commercial mobility in Saudi Arabia.",
                        },
                    ],
                    ar: [
                        {
                            type: "text",
                            value:
                                "ومن بين أكثر لحظات حفل الإطلاق ترقبًا، جاء الكشف الرسمي عن شاحنات LANDKING H-Series وEH Series، بما في ذلك الطراز الكهربائي الذي تم تقديمه خلال الحدث. وتأتي H-Series كشاحنة تجارية خفيفة مخصصة لتلبية متطلبات الأعمال التشغيلية المكثفة، في حين تعكس EH Series توجه LANDKING نحو حلول التنقل التجاري الكهربائي في المملكة العربية السعودية.",
                        },
                    ],
                },
            },

            {
                type: "paragraph",
                content: {
                    en: [
                        {
                            type: "text",
                            value:
                                "The reveal gave guests the opportunity to inspect the vehicles more closely and understand how the lineup may serve practical transport and fleet needs. Seeing the trucks in person helped connect product design with real business use cases for operators in Riyadh and other parts of Saudi Arabia.",
                        },
                    ],
                    ar: [
                        {
                            type: "text",
                            value:
                                "وأتاح هذا الكشف للحضور فرصة الاطلاع على المركبات عن قرب وفهم الكيفية التي يمكن من خلالها أن تخدم هذه الفئة احتياجات النقل والتشغيل العملي للأساطيل. كما ساعدت معاينة الشاحنات على أرض الواقع في ربط تصميم المنتج بحالات الاستخدام الفعلية لقطاع الأعمال، سواء للمشغلين في مدينة الرياض أو في مختلف مناطق المملكة العربية السعودية.",
                        },
                    ],
                },
            },


            {
                type: "paragraph",
                content: {
                    en: [
                        {
                            type: "text",
                            value:
                                "Guests were then hosted in a setting that reflected Saudi hospitality and relationship building, both of which remain important in business introductions and long-term partnerships. Overall, the event presented LANDKING as a brand seeking to build trust, local presence, and stronger customer engagement in the Saudi commercial vehicle market.",
                        },
                    ],
                    ar: [
                        {
                            type: "text",
                            value:
                                "بعد ذلك، حظي الضيوف باستضافة عكست كرم الضيافة السعودية وروح بناء العلاقات، وهما عنصران يكتسبان أهمية كبيرة في بدايات الأعمال والشراكات طويلة الأمد. وبصورة عامة، قدّم الحدث علامة LANDKING كعلامة تسعى إلى ترسيخ الثقة، وتعزيز حضورها المحلي، وبناء تفاعل أقوى مع العملاء في سوق المركبات التجارية بالمملكة العربية السعودية.",
                        },
                    ],
                },
            },


            {
                type: "paragraph",
                content: {
                    en: [
                        {
                            type: "text",
                            value:
                                "The opening of the LANDKING showroom in Riyadh is a meaningful development for businesses looking for light commercial trucks in Saudi Arabia. With BTATC leading the local presence, the showroom gives customers a direct place to explore vehicle options, discuss specifications, and engage with the brand face to face. For customers in Riyadh, this improves access to product information, dealership support, and a clearer view of the brand’s commercial vehicle offering.",
                        },
                    ],
                    ar: [
                        {
                            type: "text",
                            value:
                                "يمثل افتتاح صالة عرض LANDKING في مدينة الرياض خطوة مهمة للأعمال التي تبحث عن شاحنات تجارية خفيفة في المملكة العربية السعودية. ومع قيادة BTATC للحضور المحلي للعلامة، توفر صالة العرض للعملاء وجهة مباشرة لاستكشاف خيارات المركبات، ومناقشة المواصفات، والتواصل مع العلامة التجارية بشكل مباشر. وبالنسبة للعملاء في الرياض، فإن ذلك يسهم في تحسين الوصول إلى معلومات المنتجات، ودعم الوكيل، وتكوين صورة أوضح عن حلول المركبات التجارية التي تقدمها العلامة.",
                        },
                    ],
                },
            },


            {
                type: "paragraph",
                content: {
                    en: [
                        {
                            type: "text",
                            value:
                                "This matters for several reasons. Saudi Arabia continues to rely heavily on logistics, delivery, retail distribution, project mobility, and SME fleet activity. At the same time, buyers increasingly expect more than a vehicle alone. They look for reliability, support, warranty confidence, and futureready options. By introducing both the H-Series and the EH electric series, LANDKING signals that it is entering the market with a mix of practical utility and forward-looking mobility solutions.",
                        },
                    ],
                    ar: [
                        {
                            type: "text",
                            value:
                                "وتبرز أهمية ذلك لعدة أسباب. فالمملكة العربية السعودية تواصل الاعتماد بشكل كبير على قطاعات الخدمات اللوجستية، والتوصيل، والتوزيع التجاري، وحركة المشاريع، وأنشطة أساطيل المنشآت الصغيرة والمتوسطة. وفي الوقت نفسه، لم يعد المشترون يبحثون عن مركبة فقط، بل أصبحوا يتطلعون إلى الاعتمادية، والدعم، والثقة في الضمان، والحلول الجاهزة للمستقبل. ومن خلال تقديم كلٍ من H-Series وEH الكهربائية، تؤكد LANDKING دخولها إلى السوق بمزيج يجمع بين العملية التشغيلية والحلول المستقبلية المتقدمة في مجال التنقل التجاري."
                        },
                    ],
                },
            },


            {
                type: "paragraph",
                content: {
                    en: [
                        {
                            type: "text",
                            value:
                                "Located on Eastern Ring Road, Exit 18, the new showroom gives customers in Riyadh a practical place to explore the LANDKING brand in person. For business owners, transport operators, and fleet decisionmakers in the capital, the location creates a clear destination to review trucks, discuss requirements, and connect with the local dealership team.",
                        },
                    ],
                    ar: [
                        {
                            type: "text",
                            value:
                                "ويقع المعرض الجديد على الطريق الدائري الشرقي، مخرج 18، ليمنح العملاء في مدينة الرياض وجهة عملية للتعرّف على علامة LANDKING عن قرب. وبالنسبة لأصحاب الأعمال، ومشغلي النقل، وصنّاع القرار في قطاع الأساطيل داخل العاصمة، يوفر هذا الموقع نقطة واضحة ومباشرة لاستعراض الشاحنات، ومناقشة الاحتياجات التشغيلية، والتواصل مع فريق الوكيل المحلي."
                        }
                    ],
                },
            },


            {
                type: "paragraph",
                content: {
                    en: [
                        {
                            type: "text",
                            value:
                                "The showroom opening was more than a launch event. It was a clear statement of intent for LANDKING’s growth in Saudi Arabia. Through a professionally structured introduction to the brand, BTATC has taken an important step toward building LANDKING’s presence in the Kingdom’s commercial vehicle sector.",
                        },
                    ],
                    ar: [
                        {
                            type: "text",
                            value:
                                "لم يكن افتتاح صالة العرض مجرد فعالية إطلاق، بل كان إعلانًا واضحًا عن توجه LANDKING نحو النمو والتوسع في المملكة العربية السعودية. ومن خلال تقديم العلامة بأسلوب احترافي ومنظم، اتخذت BTATC خطوة مهمة نحو ترسيخ حضور LANDKING في قطاع المركبات التجارية داخل المملكة."
                        }
                    ],
                },
            },


            {
                type: "paragraph",
                content: {
                    en: [
                        {
                            type: "text",
                            value:
                                "From the cultural opening and leadership speeches to the vehicle reveal and customer-focused messaging, the event combined local relevance with commercial confidence. It helped introduce LANDKING in a way that balanced brand image, product visibility, and business positioning.",
                        },
                    ],
                    ar: [
                        {
                            type: "text",
                            value:
                                "ومن الافتتاح ذي الطابع الثقافي، إلى كلمات القيادات، ثم الكشف عن المركبات والرسائل الموجهة للعملاء، جمع الحدث بين الارتباط بالسوق المحلي والثقة التجارية. وقد أسهم ذلك في تقديم LANDKING بصورة متوازنة تجمع بين قوة الصورة الذهنية للعلامة، ووضوح المنتجات، وحضورها التجاري في السوق."
                        }
                    ],
                },
            },


            {
                type: "paragraph",
                content: {
                    en: [
                        {
                            type: "text",
                            value:
                                "As LANDKING grows in the Kingdom, the Riyadh showroom stands as an important step in building visibility, trust, and long-term local presence. For businesses seeking dependable commercial trucks, modern fleet solutions, and a closer look at the LANDKING H-Series and EH Series, the showroom offers a practical next step. Visit the Riyadh showroom or contact BTATC to learn more about available models and dealership support.",
                        }
                    ],
                    ar: [
                        {
                            type: "text",
                            value:
                                "ومع مواصلة LANDKING توسعها في المملكة، تمثل صالة عرض الرياض خطوة محورية في بناء الظهور، وتعزيز الثقة، وترسيخ حضور محلي طويل الأمد. وبالنسبة للأعمال التي تبحث عن شاحنات تجارية موثوقة، وحلول حديثة لإدارة الأساطيل، وفرصة أقرب للتعرّف على LANDKING H-Series وEH Series، فإن صالة العرض توفر خطوة عملية مهمة. يمكنكم زيارة صالة عرض الرياض أو التواصل مع BTATC لمعرفة المزيد حول الطرازات المتوفرة وخدمات الوكالة والدعم."
                        }
                    ],
                },
            },

            // {
            //     type: "paragraph",
            //     content: {
            //         en: [
            //             {
            //                 type: "text",
            //                 value:
            //                     "The opening featured the LANDKING H-Series and the EH Series, helping visitors understand the brand’s product direction and its commitment to dependable transport solutions. Businesses interested in dealership support or vehicle availability can ",
            //             },
            //             {
            //                 type: "link",
            //                 value: "contact the team",
            //                 href: "/contact-us",
            //                 target: "_self",
            //             },
            //             {
            //                 type: "text",
            //                 value: " for more information.",
            //             },
            //         ],
            //         ar: [
            //             {
            //                 type: "text",
            //                 value:
            //                     "وشهد الافتتاح عرض سلسلة H من لاندكنج وسلسلة EH، مما ساعد الزوار على فهم توجه العلامة التجارية والتزامها بتقديم حلول نقل موثوقة. ويمكن للشركات المهتمة بدعم الوكلاء أو توفر المركبات ",
            //             },
            //             {
            //                 type: "link",
            //                 value: "التواصل مع الفريق",
            //                 href: "/contact-us",
            //                 target: "_self",
            //             },
            //             {
            //                 type: "text",
            //                 value: " للحصول على مزيد من المعلومات.",
            //             },
            //         ],
            //     },
            // },
            // {
            //     type: "image",
            //     src: newsBody01B,
            //     alt: {
            //         en: "Visitors exploring the LANDKING brand experience at the Riyadh showroom",
            //         ar: "زوار يطلعون على تجربة علامة لاندكنج في معرض الرياض",
            //     },
            // },
        ],
    },

    //   {
    //     id: 2,
    //     slug: "landking-eh-series-for-saudi-businesses",
    //     date: "2025-12-18",
    //     featuredImage: newsFeatured02,
    //     featuredAlt: {
    //       en: "LANDKING EH Series electric commercial truck for Saudi business transport",
    //       ar: "شاحنة لاندكنج الكهربائية من سلسلة EH للنقل التجاري في السعودية",
    //     },
    //     title: {
    //       en: "Why the LANDKING EH Series Matters for Saudi Businesses",
    //       ar: "لماذا تمثل سلسلة EH من لاندكنج أهمية للأعمال في السعودية",
    //     },
    //     excerpt: {
    //       en: "The LANDKING EH Series reflects a practical move toward cleaner commercial mobility for businesses evaluating electric truck options in Saudi Arabia.",
    //       ar: "تمثل سلسلة EH من لاندكنج توجهًا عمليًا نحو تنقل تجاري أنظف للشركات التي تقيّم خيارات الشاحنات الكهربائية في السعودية.",
    //     },
    //     contentBlocks: [
    //       {
    //         type: "image",
    //         src: newsBody02A,
    //         alt: {
    //           en: "LANDKING EH Series truck positioned in a Saudi commercial environment",
    //           ar: "شاحنة لاندكنج من سلسلة EH في بيئة تجارية سعودية",
    //         },
    //       },
    //       {
    //         type: "paragraph",
    //         content: {
    //           en: [
    //             {
    //               type: "text",
    //               value:
    //                 "As Saudi Arabia continues to modernize transport and logistics, electric commercial vehicles are becoming more relevant to businesses that want to improve operating efficiency and align with future-ready mobility goals.",
    //             },
    //           ],
    //           ar: [
    //             {
    //               type: "text",
    //               value:
    //                 "ومع استمرار المملكة العربية السعودية في تطوير قطاع النقل والخدمات اللوجستية، أصبحت المركبات التجارية الكهربائية أكثر أهمية للشركات التي تسعى إلى تحسين الكفاءة التشغيلية والمواءمة مع أهداف التنقل المستقبلي.",
    //             },
    //           ],
    //         },
    //       },
    //       {
    //         type: "paragraph",
    //         content: {
    //           en: [
    //             {
    //               type: "text",
    //               value:
    //                 "The LANDKING EH Series is positioned as a strong option for businesses seeking commercial vehicles that combine modern design, operational practicality, and forward-looking fleet value.",
    //             },
    //           ],
    //           ar: [
    //             {
    //               type: "text",
    //               value:
    //                 "وتُعد سلسلة EH من لاندكنج خيارًا قويًا للشركات التي تبحث عن مركبات تجارية تجمع بين التصميم الحديث والعملية التشغيلية والقيمة المستقبلية للأسطول.",
    //             },
    //           ],
    //         },
    //       },
    //     ],
    //   },

    //   {
    //     id: 3,
    //     slug: "landking-h-series-for-daily-commercial-operations",
    //     date: "2025-12-22",
    //     featuredImage: newsFeatured03,
    //     featuredAlt: {
    //       en: "LANDKING H-Series truck built for daily commercial operations in Saudi Arabia",
    //       ar: "شاحنة لاندكنج من سلسلة H مصممة للعمليات التجارية اليومية في السعودية",
    //     },
    //     title: {
    //       en: "How the LANDKING H-Series Supports Daily Commercial Operations",
    //       ar: "كيف تدعم سلسلة H من لاندكنج العمليات التجارية اليومية",
    //     },
    //     excerpt: {
    //       en: "The LANDKING H-Series is designed to meet the practical needs of transport, logistics, and business operations that require dependable commercial trucks.",
    //       ar: "تم تصميم سلسلة H من لاندكنج لتلبية الاحتياجات العملية للنقل والخدمات اللوجستية والعمليات التجارية التي تتطلب شاحنات تجارية موثوقة.",
    //     },
    //     contentBlocks: [
    //       {
    //         type: "paragraph",
    //         content: {
    //           en: [
    //             {
    //               type: "text",
    //               value:
    //                 "For businesses managing regular movement of goods, service support, and day-to-day operations, vehicle dependability is essential. The LANDKING H-Series is built around that practical requirement.",
    //             },
    //           ],
    //           ar: [
    //             {
    //               type: "text",
    //               value:
    //                 "وبالنسبة للشركات التي تدير حركة البضائع والدعم الخدمي والعمليات اليومية بشكل منتظم، فإن موثوقية المركبة تعد أمرًا أساسيًا. وقد تم تطوير سلسلة H من لاندكنج انطلاقًا من هذا الاحتياج العملي.",
    //             },
    //           ],
    //         },
    //       },
    //       {
    //         type: "paragraph",
    //         content: {
    //           en: [
    //             {
    //               type: "text",
    //               value:
    //                 "Its positioning in the Saudi market makes it relevant for companies seeking a commercial truck that balances work-ready performance, brand confidence, and a modern professional image.",
    //             },
    //           ],
    //           ar: [
    //             {
    //               type: "text",
    //               value:
    //                 "ويجعل تموضعها في السوق السعودي منها خيارًا مناسبًا للشركات التي تبحث عن شاحنة تجارية تجمع بين الأداء العملي والثقة في العلامة التجارية والصورة المهنية الحديثة.",
    //             },
    //           ],
    //         },
    //       },
    //     ],
    //   },

    //   {
    //     id: 4,
    //     slug: "landking-brand-growth-in-saudi-arabia",
    //     date: "2026-01-05",
    //     featuredImage: newsFeatured04,
    //     featuredAlt: {
    //       en: "LANDKING commercial truck brand expanding its presence in Saudi Arabia",
    //       ar: "توسع حضور علامة لاندكنج للشاحنات التجارية في المملكة العربية السعودية",
    //     },
    //     title: {
    //       en: "LANDKING’s Brand Growth Strategy in Saudi Arabia",
    //       ar: "استراتيجية نمو علامة لاندكنج في المملكة العربية السعودية",
    //     },
    //     excerpt: {
    //       en: "LANDKING is building visibility in Saudi Arabia through local presence, product introduction, and customer-facing engagement in key business markets.",
    //       ar: "تعمل لاندكنج على بناء حضورها في السعودية عبر التواجد المحلي وتقديم المنتجات والتفاعل المباشر مع العملاء في الأسواق التجارية الرئيسية.",
    //     },
    //     contentBlocks: [
    //       {
    //         type: "paragraph",
    //         content: {
    //           en: [
    //             {
    //               type: "text",
    //               value:
    //                 "Building a commercial vehicle brand in Saudi Arabia requires more than product availability. It requires visibility, customer trust, and local engagement that helps businesses understand the value of the brand.",
    //             },
    //           ],
    //           ar: [
    //             {
    //               type: "text",
    //               value:
    //                 "إن بناء علامة تجارية للمركبات التجارية في السعودية لا يعتمد على توفر المنتج فقط، بل يتطلب أيضًا الحضور الواضح وثقة العملاء والتفاعل المحلي الذي يساعد الشركات على فهم قيمة العلامة التجارية.",
    //             },
    //           ],
    //         },
    //       },
    //       {
    //         type: "paragraph",
    //         content: {
    //           en: [
    //             {
    //               type: "text",
    //               value:
    //                 "Through its Riyadh showroom and customer-focused communication, LANDKING is taking visible steps to establish long-term presence in the Kingdom’s commercial transport market.",
    //             },
    //           ],
    //           ar: [
    //             {
    //               type: "text",
    //               value:
    //                 "ومن خلال معرضها في الرياض وتواصلها الموجه للعملاء، تتخذ لاندكنج خطوات واضحة نحو ترسيخ حضور طويل المدى في سوق النقل التجاري بالمملكة.",
    //             },
    //           ],
    //         },
    //       },
    //     ],
    //   },

    //   {
    //     id: 5,
    //     slug: "modern-commercial-truck-solutions-in-saudi-market",
    //     date: "2026-01-12",
    //     featuredImage: newsFeatured05,
    //     featuredAlt: {
    //       en: "Modern commercial truck solutions for Saudi transport and business needs",
    //       ar: "حلول شاحنات تجارية حديثة لاحتياجات النقل والأعمال في السعودية",
    //     },
    //     title: {
    //       en: "Modern Commercial Truck Solutions for Saudi Market Needs",
    //       ar: "حلول الشاحنات التجارية الحديثة لاحتياجات السوق السعودي",
    //     },
    //     excerpt: {
    //       en: "Saudi businesses are looking for commercial vehicles that combine reliability, presentation, and operational value in a changing transport market.",
    //       ar: "تبحث الشركات السعودية عن مركبات تجارية تجمع بين الاعتمادية والحضور والقيمة التشغيلية في سوق نقل متغير.",
    //     },
    //     contentBlocks: [
    //       {
    //         type: "paragraph",
    //         content: {
    //           en: [
    //             {
    //               type: "text",
    //               value:
    //                 "Today’s transport market requires more than simple utility. Businesses increasingly evaluate commercial vehicles based on daily usability, long-term value, and the confidence they create in front of customers and operational teams.",
    //             },
    //           ],
    //           ar: [
    //             {
    //               type: "text",
    //               value:
    //                 "يتطلب سوق النقل اليوم أكثر من مجرد الاستخدام الأساسي. فالشركات تقيم المركبات التجارية بشكل متزايد بناءً على سهولة الاستخدام اليومي والقيمة طويلة المدى والثقة التي تعكسها أمام العملاء وفرق التشغيل.",
    //             },
    //           ],
    //         },
    //       },
    //       {
    //         type: "paragraph",
    //         content: {
    //           en: [
    //             {
    //               type: "text",
    //               value:
    //                 "That is where brands like LANDKING are becoming relevant in Saudi Arabia, especially for businesses seeking practical, modern, and commercially aligned vehicle solutions.",
    //             },
    //           ],
    //           ar: [
    //             {
    //               type: "text",
    //               value:
    //                 "وهنا تبرز أهمية علامات مثل لاندكنج في السعودية، خصوصًا للشركات التي تبحث عن حلول مركبات عملية وحديثة ومتوافقة مع متطلبات السوق التجاري.",
    //             },
    //           ],
    //         },
    //       },
    //     ],
    //   },
];

export default newsData;